export default "__VITE_ASSET__CJb0rPxg__"